import { saveCode } from './cloudsave'
import { RESOLVER_URL } from '../web3/contract'

// Télémétrie produit (audit phase 6) — pseudonyme (saveCode), zéro PII.
// Envoi « best-effort »: on n'attend pas la réponse et on n'échoue jamais.
// Chaque étape de funnel n'est comptée qu'une fois par joueur côté serveur.

export type MetricEvent =
  | 'demo_start' // première ouverture / premier combat
  | 'first_battle'
  | 'tutorial_done'
  | 'wallet_connect'
  | 'mint'
  | 'first_pvp'

// Anti-doublon local: inutile de re-poster une étape déjà envoyée ce chargement.
const sent = new Set<string>()

export function track(event: MetricEvent): void {
  if (!RESOLVER_URL) return
  const key = event
  if (sent.has(key)) return
  sent.add(key)
  try {
    void fetch(`${RESOLVER_URL}/metrics`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ save: saveCode(), event }),
      keepalive: true, // survit à une navigation
    }).catch(() => {})
  } catch {
    // jamais bloquant
  }
}
